import React from "react";
import { ArrowUpRight } from "lucide-react";
import { buildWhatsAppLink } from "../constants";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 sm:py-32 bg-page overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.04]">
        <span className="font-heading text-[300px] sm:text-[420px] tracking-tighter text-vino">
          Vallitas
        </span>
      </div>

      <div className="relative max-w-5xl mx-auto px-6 sm:px-10 text-center">
        <div className="label-eyebrow mb-6">Tu prenda te espera</div>
        <h2
          data-testid="final-cta-title"
          className="font-heading text-5xl sm:text-7xl lg:text-8xl tracking-tighter text-ink leading-[0.95]"
        >
          Diseña tu prenda
          <br />
          <span className="italic text-vino">hoy</span>.
        </h2>
        <p className="mt-8 max-w-xl mx-auto text-base sm:text-lg text-ink-soft leading-relaxed">
          Cuéntanos qué tienes en mente. Te respondemos en minutos por WhatsApp
          y empezamos a darle forma a tu idea.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={buildWhatsAppLink("Hola Vallitas, quiero diseñar mi prenda hoy.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp"
            className="group inline-flex items-center gap-2 rounded-full bg-vino text-page px-9 py-5 text-base font-medium hover:bg-vino-deep transition-all hover:-translate-y-1 shadow-[0_24px_60px_-15px_rgba(114,47,55,0.6)]"
          >
            Empezar por WhatsApp
            <ArrowUpRight
              size={20}
              className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </a>
          <a
            href="#productos"
            data-testid="final-cta-secondary"
            className="inline-flex items-center gap-2 rounded-full border border-vino/30 text-ink px-9 py-5 text-base font-medium hover:bg-sand transition-colors"
          >
            Ver productos
          </a>
        </div>

        <p className="mt-6 text-xs uppercase tracking-[0.25em] text-ink-soft">
          Confección desde $10 · Hecho en Venezuela
        </p>
      </div>
    </section>
  );
}
